import React, { useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '../../components/ui/Table';
import { Button } from '../../components/ui/Button';
import { Save, RefreshCw, Calculator } from 'lucide-react';
export function DynamicPricing() {
  const [basePrice, setBasePrice] = useState(10000);
  const [markupPercent, setMarkupPercent] = useState(15);
  const [serviceFee, setServiceFee] = useState(500);
  const [commission, setCommission] = useState(5);
  const markupValue = basePrice * (markupPercent / 100);
  const commissionValue = (basePrice + markupValue) * (commission / 100);
  const finalPrice = basePrice + markupValue + serviceFee + commissionValue;
  return <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-531">
      {/* Pricing Rules Table */}
      <div className="lg:col-span-2 space-y-6" data-id="element-532">
        <div className="flex justify-between items-center" data-id="element-533">
          <h3 className="text-lg font-bold text-slate-800" data-id="element-534">
            Regional Pricing Rules
          </h3>
          <Button variant="outline" size="sm" icon={<RefreshCw className="w-4 h-4" data-id="element-536" />} data-id="element-535">
            Sync Prices
          </Button>
        </div>

        <Table data-id="element-537">
          <TableHeader data-id="element-538">
            <TableRow data-id="element-539">
              <TableHead data-id="element-540">Region</TableHead>
              <TableHead data-id="element-541">Markup</TableHead>
              <TableHead data-id="element-542">Service Fee</TableHead>
              <TableHead data-id="element-543">Commission</TableHead>
              <TableHead className="text-right" data-id="element-544">Action</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody data-id="element-545">
            <TableRow data-id="element-546">
              <TableCell data-id="element-547">
                <span className="font-bold text-slate-900" data-id="element-548">
                  Jawa Barat (Default)
                </span>
              </TableCell>
              <TableCell data-id="element-549">
                <div className="flex items-center gap-2" data-id="element-550">
                  <input type="number" className="w-16 p-1 border rounded text-sm" defaultValue={15} data-id="element-551" />
                  <span className="text-slate-500" data-id="element-552">%</span>
                </div>
              </TableCell>
              <TableCell data-id="element-553">
                <div className="flex items-center gap-2" data-id="element-554">
                  <span className="text-slate-500" data-id="element-555">Rp</span>
                  <input type="number" className="w-20 p-1 border rounded text-sm" defaultValue={500} data-id="element-556" />
                </div>
              </TableCell>
              <TableCell data-id="element-557">
                <div className="flex items-center gap-2" data-id="element-558">
                  <input type="number" className="w-16 p-1 border rounded text-sm" defaultValue={5} data-id="element-559" />
                  <span className="text-slate-500" data-id="element-560">%</span>
                </div>
              </TableCell>
              <TableCell className="text-right" data-id="element-561">
                <Button size="sm" variant="ghost" className="text-blue-600" data-id="element-562">
                  Update
                </Button>
              </TableCell>
            </TableRow>
            <TableRow data-id="element-563">
              <TableCell data-id="element-564">
                <span className="font-medium" data-id="element-565">Jawa Tengah</span>
              </TableCell>
              <TableCell data-id="element-566">12%</TableCell>
              <TableCell data-id="element-567">Rp 500</TableCell>
              <TableCell data-id="element-568">5%</TableCell>
              <TableCell className="text-right" data-id="element-569">
                <Button size="sm" variant="ghost" data-id="element-570">
                  Edit
                </Button>
              </TableCell>
            </TableRow>
            <TableRow data-id="element-571">
              <TableCell data-id="element-572">
                <span className="font-medium" data-id="element-573">Jawa Timur</span>
              </TableCell>
              <TableCell data-id="element-574">14%</TableCell>
              <TableCell data-id="element-575">Rp 750</TableCell>
              <TableCell data-id="element-576">5%</TableCell>
              <TableCell className="text-right" data-id="element-577">
                <Button size="sm" variant="ghost" data-id="element-578">
                  Edit
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>

      {/* Simulator Panel */}
      <div className="space-y-6" data-id="element-579">
        <Card className="p-6 sticky top-24 border-blue-100 bg-blue-50/50" data-id="element-580">
          <div className="flex items-center gap-2 mb-6 text-blue-800" data-id="element-581">
            <Calculator className="w-5 h-5" data-id="element-582" />
            <h3 className="font-bold text-lg" data-id="element-583">Price Simulator</h3>
          </div>

          <div className="space-y-4" data-id="element-584">
            <div data-id="element-585">
              <label className="block text-xs font-bold text-slate-500 uppercase mb-1" data-id="element-586">
                Base Price (Supplier)
              </label>
              <div className="relative" data-id="element-587">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 font-medium" data-id="element-588">
                  Rp
                </span>
                <input type="number" value={basePrice} onChange={e => setBasePrice(Number(e.target.value))} className="w-full pl-10 pr-4 py-2 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 outline-none" data-id="element-589" />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4" data-id="element-590">
              <div data-id="element-591">
                <label className="block text-xs font-bold text-slate-500 uppercase mb-1" data-id="element-592">
                  Markup (%)
                </label>
                <input type="number" value={markupPercent} onChange={e => setMarkupPercent(Number(e.target.value))} className="w-full px-3 py-2 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 outline-none" data-id="element-593" />
              </div>
              <div data-id="element-594">
                <label className="block text-xs font-bold text-slate-500 uppercase mb-1" data-id="element-595">
                  Fee (Rp)
                </label>
                <input type="number" value={serviceFee} onChange={e => setServiceFee(Number(e.target.value))} className="w-full px-3 py-2 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 outline-none" data-id="element-596" />
              </div>
            </div>

            <div className="pt-4 border-t border-blue-200 space-y-2" data-id="element-597">
              <div className="flex justify-between text-sm" data-id="element-598">
                <span className="text-slate-600" data-id="element-599">Base Price</span>
                <span className="font-medium" data-id="element-600">
                  Rp {basePrice.toLocaleString()}
                </span>
              </div>
              <div className="flex justify-between text-sm" data-id="element-601">
                <span className="text-slate-600" data-id="element-602">
                  Markup ({markupPercent}%)
                </span>
                <span className="font-medium text-green-600" data-id="element-603">
                  + Rp {markupValue.toLocaleString()}
                </span>
              </div>
              <div className="flex justify-between text-sm" data-id="element-604">
                <span className="text-slate-600" data-id="element-605">Service Fee</span>
                <span className="font-medium text-green-600" data-id="element-606">
                  + Rp {serviceFee.toLocaleString()}
                </span>
              </div>
              <div className="flex justify-between text-sm" data-id="element-607">
                <span className="text-slate-600" data-id="element-608">
                  Commission ({commission}%)
                </span>
                <span className="font-medium text-green-600" data-id="element-609">
                  + Rp {commissionValue.toLocaleString()}
                </span>
              </div>

              <div className="flex justify-between items-center pt-4 border-t border-blue-200" data-id="element-610">
                <span className="font-bold text-slate-900" data-id="element-611">Final Price</span>
                <span className="font-extrabold text-2xl text-blue-600" data-id="element-612">
                  Rp {finalPrice.toLocaleString()}
                </span>
              </div>
            </div>

            <Button variant="primary" fullWidth icon={<Save className="w-4 h-4" data-id="element-614" />} data-id="element-613">
              Apply to All Products
            </Button>
          </div>
        </Card>
      </div>
    </div>;
}